import { Documents } from 'src/ui/fragments'

export const Section5 = () => {
  return <Documents />
}
